module.exports = __webpack_public_path__ + "6f1bf8ddf0e54767823f1ddfc57eaa5d.jpg";